import React, { FC } from 'react';
import { Box, Text } from '@bechtel/gds';
import { Plural, t } from '@lingui/macro';
import { TextWithEllipsis, useDate } from '@bechtel/client-common';
import { RodRequest } from '@bechtel/types';
import { RodRequestStatusStyled } from '~/request/styled';

export const RodRequestItem: FC<RodRequest> = (rodRequest) => {
  const { formatISODate } = useDate();

  return (
    <Box flexDirection={{ sm: 'row' }} css="overflow:hidden">
      <RodRequestStatusStyled status={rodRequest.currentStatusI18n} data-testid="rod-request-card" />
      <Box justifyContent={{ sm: 'space-between' }} alignItems={{ sm: 'center' }} css={{ flex: 1 }}>
        <Box flexDirection={{ sm: 'column' }}>
          <TextWithEllipsis size="300" family="graphik" data-testid="request-card-date">
            {formatISODate(rodRequest?.createdAt, 'dd-MMM  HH:mm aa')}
          </TextWithEllipsis>
          <Box mb={{ sm: '300' }}>
            <TextWithEllipsis
              data-testid="rod-request-name"
              family="graphik"
              size="500"
              transform="uppercase"
              color="grey.1000"
              weight="600"
            >
              {rodRequest?.requestNumber}
            </TextWithEllipsis>
          </Box>
          <Box pb={{ sm: '200' }}>
            <Text color="blue.700" size="300" weight="800" data-testid="rod-Request-weld-count">
              {rodRequest.welds?.length}&nbsp;
              <Text size="300" weight="400" color="blue.700">
                {rodRequest.welds?.length > 1 ? t`Welds` : t`Weld`}
              </Text>
            </Text>
          </Box>
        </Box>
        <Box style={{ opacity: 0.5 }} alignItems={{ sm: 'center' }}>
          <Text size="400" weight="800" color="black">
            {rodRequest?.stencils?.length}
          </Text>
          &nbsp;
          <Text size="400" weight="600" color="black">
            <Plural value={rodRequest?.stencils?.length} one={` Welder`} other={` Welders`} />
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
